import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface TopNavigationProps {
  onClose?: () => void;
  isOpen?: boolean;
  onToggleSidebar?: () => void;
}

interface NavItem {
  id: string;
  label: string;
  path: string;
  hasDropdown?: boolean;
  isSpecial?: boolean;
}

const TopNavigation: React.FC<TopNavigationProps> = ({ onClose, isOpen = false, onToggleSidebar }) => {
  const location = useLocation();
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navItems: NavItem[] = [
    { id: 'inicio', label: 'Inicio', path: '/' },
    { id: 'quienes-somos', label: 'Quiénes Somos', path: '/quienes-somos' },
    { id: 'servicios', label: 'Servicios', path: '/servicios', hasDropdown: true },
    { id: 'galeria', label: 'Galeria', path: '/galeria' },
    //{ id: 'cotizador', label: 'Cotizador', path: '/cotizador', isSpecial: true }
  ];

  const services = [
    { name: 'Baños Portátiles VIP', path: '/servicios/banos-portatiles-vip' },
    { name: 'Baños Portátiles Estándar', path: '/servicios/banos-portatiles-estandar' },
    { name: 'Baños para Discapacitados', path: '/servicios/banos-para-discapacitados' },
    { name: 'Baños Portátiles Eléctricos', path: '/servicios/banos-portatiles-electricos' },
    { name: 'Lavamanos Aquastand y Aquapop', path: '/servicios/lavamanos-aquastand-aquapop' },
    { name: 'Tráiler de Lujo', path: '/servicios/trailer-de-lujo' },
    { name: 'Servicio de Operarios', path: '/servicios/servicio-de-operarios' },
    { name: 'Puntos Ecológicos', path: '/servicios/puntos-ecologicos' }
  ];

  const handleNavClick = () => {
    // Close navigation on mobile after navigation
    if (onClose && window.innerWidth <= 1024) {
      onClose();
    }
    setIsServicesDropdownOpen(false);
  };

  const handleDropdownToggle = (e: React.MouseEvent) => {
    if (isMobile) {
      e.preventDefault();
      setIsServicesDropdownOpen(!isServicesDropdownOpen);
    }
  };

  return (
    <nav className={`top-navigation-mockup ${isOpen ? 'nav-open' : ''}`}>
      <div className="top-nav-left-mockup">
        <button 
          className="mobile-menu-toggle-industrial"
          onClick={onToggleSidebar}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <img 
          src="/images/logo.png" 
          alt="Junisama Inversiones S.A.S" 
          className="top-nav-logo-mockup"
        />
      </div>
      
      <div className="top-nav-center-mockup">
        <ul className="top-nav-list-mockup">
          {navItems.map((item, index) => (
            <li
              key={`${item.id}-${index}`}
              className={`top-nav-item-mockup ${item.hasDropdown ? 'dropdown-industrial' : ''}`}
              onMouseEnter={() => !isMobile && item.hasDropdown && setIsServicesDropdownOpen(true)}
              onMouseLeave={() => !isMobile && item.hasDropdown && setIsServicesDropdownOpen(false)}
            >
              <Link
                to={item.path}
                className={`top-nav-link-mockup ${location.pathname === item.path ? 'active' : ''} ${item?.isSpecial ? 'contact-link-mockup' : ''} ${item?.hasDropdown ? 'dropdown-toggle-industrial' : ''}`}
                onClick={item.hasDropdown ? handleDropdownToggle : handleNavClick}
                aria-current={location.pathname === item.path ? 'page' : undefined}
              >
                {item.label}
                {item.hasDropdown && <span className="dropdown-arrow-industrial">▼</span>}
              </Link>

              {item.hasDropdown && (
                <ul className={`dropdown-menu-industrial ${isServicesDropdownOpen ? 'show' : ''}`}>
                  {services.map((service, serviceIndex) => (
                    <li key={serviceIndex}>
                      <Link to={service.path} onClick={handleNavClick}>
                        {service.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className="top-nav-right-mockup">
        <a 
          href="tel:+573507089584" 
          className="btn-industrial btn-industrial-primary nav-emergency-btn"
          aria-label="Llamar para emergencias"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
          <span>🚨</span>
          <span className="emergency-text">EMERGENCIA</span>
        </a>
      </div>
    </nav>
  );
};

export default TopNavigation;